module.exports = __webpack_public_path__ + "img/big.6bcbe233.jpg";